import React, { Component } from 'react';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { getUserRole } from '../../../../services/common/util';

export default class EditBtnCellRenderer extends Component {
    constructor(props) {
        super(props);
    }

    handleEdit = () => {
        this.props.context.componentParent.handleEdit(this.props.data);
    };

    handleDelete = () => {
        this.props.context.componentParent.handleDelete(this.props.data._id);
    };

    renderTooltipEdit = (props) => (
        <Tooltip id="button-tooltip" {...props}>
            Edit Rule
        </Tooltip>
    );

    renderTooltipDelete = (props) => (
        <Tooltip id="button-tooltip" {...props}>
            Delete Rule
        </Tooltip>
    );

    render() {
        const canManage = getUserRole() && /superadmin|admin|labtech/.test(getUserRole().toLowerCase());

        if (!canManage) {
            return null;
        }

        return (
            <div>
                <OverlayTrigger placement="top" delay={{ show: 50, hide: 100 }} overlay={this.renderTooltipEdit}>
                    <button
                        onClick={this.handleEdit}
                        style={{
                            border: 'none',
                            backgroundColor: 'transparent'
                        }}
                    >
                        <i className="fas fa-pen"></i>
                    </button>
                </OverlayTrigger>

                <OverlayTrigger placement="top" delay={{ show: 50, hide: 100 }} overlay={this.renderTooltipDelete}>
                    <button
                        onClick={this.handleDelete}
                        style={{
                            border: 'none',
                            backgroundColor: 'transparent',
                            marginLeft: '10px'
                        }}
                    >
                        <i className="fas fa-trash text-danger"></i>
                    </button>
                </OverlayTrigger>
            </div>
        );
    }
}
